var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "Forms_svg__[object_Object]b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F9FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E7FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "Forms_svg__[object_Object]a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E9DFE",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B97AD3",
    stopOpacity: 0.2,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "Forms_svg__[object_Object]c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1B2FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D079EC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 .5A7.5 7.5 0 00.5 8v34A7.5 7.5 0 008 49.5h34a7.5 7.5 0 007.5-7.5V8A7.5 7.5 0 0042 .5H8z",
    stroke: "url(#Forms_svg__[object_Object]a)",
    fill: "url(#Forms_svg__[object_Object]b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 22v6c0 1.591-1.193 3-3 3h-5c-.602 0-1-.47-1-1s.398-1 1-1h5c.602 0 1-.47 1-1v-6c0-.53-.398-1-1-1h-5c-.602 0-1-.47-1-1s.398-1 1-1h5c1.807 0 3 1.409 3 3zm-15.273-9h.546A3.81 3.81 0 0125 14.15 3.805 3.805 0 0127.727 13h.546a1.09 1.09 0 110 2.182h-.546c-.903 0-1.726.733-1.727 1.636v16.364c.001.903.824 1.635 1.727 1.636h.546a1.09 1.09 0 110 2.182h-.546A3.805 3.805 0 0125 35.85 3.805 3.805 0 0122.273 37h-.546a1.09 1.09 0 110-2.182h.546c.903 0 1.726-.733 1.727-1.636V16.818c-.001-.903-.824-1.635-1.727-1.636h-.546a1.09 1.09 0 110-2.182zM21 29c.602 0 1 .47 1 1s-.398 1-1 1h-5c-1.807 0-3-1.409-3-3v-6c0-1.591 1.193-3 3-3h5c.602 0 1 .47 1 1s-.398 1-1 1h-5c-.602 0-1 .47-1 1v6c0 .53.398 1 1 1h5z",
    fill: "url(#Forms_svg__[object_Object]c)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms);
export default ForwardRef;